import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type RdProjectDetailAnalyticIds = {
  detailTabId: string;
  eligibilityTabId: string;
  teamMembersTabId: string;
  ticketsTabId: string;
  tabHashMapping: Record<string, string>;
};

export const useRdProjectDetailTabIds = (): RdProjectDetailAnalyticIds => {
  const tabIds = {
    detailTabId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DRAWER_DETAIL_TAB),
    eligibilityTabId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DRAWER_ELIGIBILITY_TAB),
    teamMembersTabId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DRAWER_CONTRIBUTOR_TAB),
    ticketsTabId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DRAWER_TICKETS_TAB),
  };

  const tabHashMapping = {
    [tabIds.detailTabId]: '',
    [tabIds.eligibilityTabId]: 'eligibility',
    [tabIds.teamMembersTabId]: 'team',
    [tabIds.ticketsTabId]: 'tickets',
  };

  return { ...tabIds, tabHashMapping };
};
